"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=1832%3A476))
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const ZoomIn = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.357 10.149a8.791 8.791 0 1 1 15.061 6.162.5.5 0 0 0-.107.107 8.791 8.791 0 0 1-14.955-6.27m15.353 7.268a9.76 9.76 0 0 1-6.562 2.523c-5.407 0-9.791-4.384-9.791-9.791C.357 4.74 4.74.357 10.148.357c5.408 0 9.792 4.384 9.792 9.792a9.76 9.76 0 0 1-2.523 6.56l6.08 6.08a.5.5 0 0 1-.708.707z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.786 6a.5.5 0 1 0-1 0v3.786H6a.5.5 0 1 0 0 1h3.786v3.785a.5.5 0 1 0 1 0v-3.785h3.785a.5.5 0 1 0 0-1h-3.785z"
      fill="currentColor"
    />
  </>,
  "ZoomIn",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Zoom in",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
